<template>
    <div>
       <div style="margin-left:8px;border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-right: 4px;padding-bottom: 6px;height: 90vh;margin-bottom:50px;">
           <div style="display: flex;flex-wrap: wrap;">

               <div style="background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;height:82vh;padding: 0px 30px; overflow: auto;">
                   <div style="">

                       <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 10px; font-size: 15px;font-weight: 900;">入职信息</div>
                       <el-progress :percentage="100"></el-progress>

                       <div style="display: flex;margin-top: 30px; justify-content: space-between;flex-wrap: wrap;">

                           <div style="width: 24%;margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">简历附件</div>
                               <div style="width: 100%; ">
                                   <div style="line-height: 34px;background-color: #F5F7FA;border-radius: 4px;border: 1px solid #DCDFE6; height: 37px; white-space: nowrap; overflow: hidden;text-overflow: ellipsis;">{{ resumeNumber1 }}</div>
                               </div>
                           </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">姓名</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber2" type="text" show-word-limit maxlength="4" placeholder="请输入姓名"></el-input>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">入职岗位</div>
                               <div style="">
                                   <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber3" autocomplete="off" placeholder="请选择入职岗位" clearable>
                                       <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">性别</div>
                               <div style="">
                                   <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber4" autocomplete="off" placeholder="请选择性别" clearable>
                                       <el-option v-for="jobStatu in jobsss" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">是否住宿</div>
                               <div style="">
                                   <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber5" autocomplete="off" placeholder="请选择是否住宿" clearable>
                                       <el-option v-for="jobStatu in jobssss" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div>


                           <div style="width: 24%;margin-bottom: 30px; ">
                               <div style="text-align: start;margin-bottom: 10px;font-weight: 900;">入职日期</div>
                               <el-date-picker style="width: 100%;" :disabled="isDisabled"  v-model="resumeNumber6" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                           </div>


                           <!-- <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">员工状态</div>
                               <div style="">
                                   <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber7" autocomplete="off" placeholder="请选择员工状态" clearable>
                                       <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div> -->


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">手机号</div>
                               <div style="">
                                   <el-input @input="resumeNumber12 = $event.replace(/\D/g, '')" :disabled="isDisabled" v-model="resumeNumber12" type="text" show-word-limit maxlength="11" placeholder="请输入手机号"></el-input>
                               </div>
                           </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">邮箱</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber13" type="text" show-word-limit  placeholder="请输入邮箱"></el-input>
                               </div>
                           </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">学历</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber21" type="text" show-word-limit maxlength="4" placeholder="请输入学历"></el-input>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">科目</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber22" type="text" show-word-limit maxlength="4" placeholder="请输入科目"></el-input>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">毕业院校</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber23" type="text" show-word-limit maxlength="4" placeholder="请输入毕业院校"></el-input>
                               </div>
                          </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">试用期(月)</div>
                               <div style="">
                                   <el-input v-model="resumeNumber8" type="text" show-word-limit maxlength="2" placeholder="请输入试用期"></el-input>
                               </div>
                           </div>


                           <div style="width: 24%;margin-bottom: 30px; ">
                               <div style="text-align: start;margin-bottom: 10px;font-weight: 900;">预计转正日期</div>
                               <el-date-picker style="width: 100%;" v-model="resumeNumber9" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">社保</div>
                               <div style="">
                                   <el-input  v-model="resumeNumber10" type="text" show-word-limit maxlength="30" placeholder="请输入社保"></el-input>
                               </div>
                           </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">是否毕业<span style="color:red;font-size: 12px;">（必填）</span></div>
                               <div style="">
                                   <el-select style="width: 100%" filterable  v-model="resumeNumber11" autocomplete="off" placeholder="请选择是否毕业" clearable>
                                       <el-option v-for="jobStatu in jobss" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">身份证号<span style="color:red;font-size: 12px;">（必填）</span></div>
                               <div style="">
                                   <el-input  v-model="resumeNumber19" type="text" show-word-limit maxlength="30" placeholder="请输入身份证号"></el-input>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">正式培训时间<span style="color:red;font-size: 12px;">（必填）</span></div>
                               <div style="">
                                <el-date-picker style="width: 100%;" v-model="resumeNumber20" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">现居住地址<span style="color:red;font-size: 12px;">（必填）</span></div>
                               <div style="">
                                   <el-input v-model="resumeNumber30" type="text" show-word-limit maxlength="50" placeholder="请输入现居住地址"></el-input>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">紧急联系人姓名<span style="color:red;font-size: 12px;">（必填）</span></div>
                               <div style="">
                                   <el-input v-model="resumeNumber31" type="text" show-word-limit maxlength="4" placeholder="请输入紧急联系人姓名"></el-input>
                               </div>
                           </div>

                           <div style="width: 24%; margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">紧急联系人电话<span style="color:red;font-size: 12px;">（必填）</span></div>
                               <div style="">
                                   <el-input v-model="resumeNumber32" type="text" show-word-limit maxlength="11" placeholder="请输入紧急联系人电话"></el-input>
                               </div>
                           </div>


                           <div style="width: 24%; margin-bottom: 30px;">
                              <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">证书附件<span style="color:red;font-size: 12px;">（必填）</span></div>
                              <div style="">
                                  <el-button style="width: 100%;" type="primary" plain @click="handleShowUpload1" >上传证书附件<span style="color:red;font-size: 12px;margin-left: 10px;">({{ resumeNumber33.length }})</span></el-button>
                              </div>
                           </div>



                           <div style="width: 24%; margin-bottom: 30px;"> </div>
                           <div style="width: 24%; margin-bottom: 30px;"> </div>


                       </div>


                       <!-- <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;">账户信息</div>
                       <el-progress :percentage="100"></el-progress>

                       <div style="display: flex;margin-top: 30px; justify-content: space-between;flex-wrap: wrap; justify-content: space-between;">

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">参保城市</div>
                               <div style="display: flex;">
                                  <el-input  v-model="resumeNumber14" type="text" show-word-limit maxlength="50" placeholder="请输入参保城市"></el-input>
                               </div>
                           </div>

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">社保账号</div>
                               <div style="display: flex;">
                                  <el-input  v-model="resumeNumber15" type="text" show-word-limit maxlength="50" placeholder="请输入社保账号"></el-input>
                               </div>
                           </div>

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">公积金账号</div>
                               <div style="display: flex;">
                                  <el-input v-model="resumeNumber16" type="text" show-word-limit maxlength="50" placeholder="请输入公积金账号"></el-input>
                               </div>
                           </div>

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">银行卡号</div>
                               <div style="display: flex;">
                                  <el-input v-model="resumeNumber17" type="text" show-word-limit maxlength="50" placeholder="请输入银行卡号"></el-input>
                               </div>
                           </div>

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">开户行</div>
                               <div style="display: flex;">
                                  <el-input v-model="resumeNumber18" type="text" show-word-limit maxlength="50" placeholder="请输入开户行"></el-input>
                               </div>
                           </div>

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;">

                           </div>

                       </div> -->


                   </div>
               </div>

               <div style="width: 100%;background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding: 10px 0px;display: flex;justify-content: end; padding-right: 25px;">
                       <span slot="footer" class="dialog-footer">
                           <el-button size="small"  @click="handleShowAddTemplateDialogCler">取 消</el-button>
                           <el-button size="small" type="primary" @click="handleShowAddTemplateDialogSub">提 交</el-button>
                       </span>
               </div>

           </div>

       </div>

       <div class="box"  v-if="uploadShowDlong">
               <div style="position: absolute; top: 14px;right: 25px;font-size: 20px;"><i class="el-icon-close"  @click="uploadShowDlongCler"></i></div>
               <el-upload class="upload-demo" style="height: 350px;"
                   drag
                   action="#"
                   :on-remove="handleRemove"
                   :beforeUpload="beforeUpload"
                   :http-request="handleUpload"
                   :on-error="handleError"
                   :auto-upload="true"
                   :limit="1"
                   show-file-list
                   :file-list="fileDataList">
                   <i class="el-icon-upload"></i>
                   <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
               </el-upload>
               <div slot="footer" class="dialog-footer">
                   <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="uploadShowDlongCler">取消</el-button>
                   <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="uploadShowDlongSub">保存</el-button>
               </div>
        </div>



        <el-dialog title="上传证书附件" width="50%" style="padding: 50px 50px;" modal-append-to-body	append-to-body  :visible.sync="uploadShowDlong1"  :before-close="uploadShowDlongCler1"  :close-on-click-modal="false">
            <el-upload class="upload-demo" style="height: 350px;"
                drag
                action="#"
                :on-remove="handleRemove1"
                :beforeUpload="beforeUpload1"
                :http-request="handleUpload1"
                :on-error="handleError1"
                :auto-upload="true"
                :limit="100"
                show-file-list
                :file-list="fileDataList1">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将证书文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="uploadShowDlongCler1">取消</el-button>
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="uploadShowDlongSub1">保存</el-button>
            </div>
        </el-dialog>


    </div>
</template>


   <script>
   import axios from "axios";
   import apiBaseUrl from "../../../config/api";
   import loadingUtils from "../../utils/loading";
   import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";



   export default {
       props:{
          RowData:{
            type:Object,
            default:() => {
               return {

               }
            }
          },
          initObj:{
            type:Object,
            default:() => {
               return {

               }
            }
          },
          resumesId:{
             type:String,
             default:'',
          },
       },
       data(){
           return{

               jobs:[],
               isDisabled: true,

               fileDataList1:[],

               resumeNumber1: '',
               resumeNumber2: '',
               resumeNumber3: '',
               resumeNumber4: '',
               resumeNumber5: '',
               resumeNumber6: '',
               resumeNumber7: '',
               resumeNumber8: '',
               resumeNumber9: '',
               resumeNumber10: '',
               resumeNumber11: '',
               resumeNumber12: '',
               resumeNumber13: '',
               resumeNumber14: '',
               resumeNumber15: '',
               resumeNumber16: '',
               resumeNumber17: '',
               resumeNumber18: '',
               resumeNumber19: '',
               resumeNumber20: '',

               optionList2:[{id:1,realname:'拒接offer'},{id:2,realname:'待入职'},{id:3,realname:'已入职'}],


               uploadShowDlong: false,
               fileDataList:[],


               jobss:[{jobId:1, jobName:'是'},{jobId:0, jobName:'否'}],
               jobsss:[{jobId:1, jobName:'男'},{jobId:2, jobName:'女'}],
               jobssss:[{jobId:0, jobName:'否'},{jobId:1, jobName:'是'}],
               resumeNumber3Url: '',


               resumeNumber21: '',
               resumeNumber22: '',
               resumeNumber23: '',



               resumeNumber30: '',
               resumeNumber31: '',
               resumeNumber32: '',
               resumeNumber33: '',


               uploadShowDlong1: false,
           }
       },

       mounted(){

           axios.get(`${apiBaseUrl}/teacher/query/job`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {this.jobs = res.data.data.list})

           this.handleSetisInit()

       },


       methods:{

        handleShowUpload1(){
            this.uploadShowDlong1 = true
        },


           handleSetisInit(){



              console.log(this.RowData , 'RowData')
              console.log(this.initObj , 'initObj')

              if(this.initObj){

                 this.resumeNumber2 = this.initObj.name
                 this.resumeNumber3 = this.initObj.deptName
                 this.resumeNumber4 = this.initObj.sex === 1 ? '男' : '女'
                 this.resumeNumber5 = this.initObj.isStay === 1 ? '是' : '否'
                 this.resumeNumber6 = this.initObj.reportTime ? this.initObj.reportTime.substring(0,10) : ''
                 this.resumeNumber12 = this.initObj.telPhone
                 this.resumeNumber13 = this.initObj.email

                 this.resumeNumber21 = this.RowData.education
                 this.resumeNumber22 = (this.RowData.categoryNames.length > 0 && this.RowData.categoryNames) ? this.RowData.categoryNames.join(',') : ''
                 this.resumeNumber23 = this.RowData.graduationSchool

                 this.resumeNumber8 = this.RowData.probationPeriod ? this.RowData.probationPeriod : this.initObj.probationPeriod ? this.initObj.probationPeriod : ''


                if(this.initObj.noteUrl){
                    let newUrl = JSON.parse(this.initObj.noteUrl)
                    this.resumeNumber1 = newUrl.name
                }

              }

              if(this.RowData){

              }

           },


           handleShowAddTemplateDialogSub(){
              if(this.resumeNumber19 && this.resumeNumber30 && this.resumeNumber31 && this.resumeNumber32 && this.resumeNumber33 && this.resumeNumber20){
                 this.handleSetApiAddEntryTeacher()
              }else{
                this.$message({type: 'warning', message: '请添加必填项~' })
              }
            //   this.$emit('handleEventChildren', false)
           },

           handleSetApiAddEntryTeacher(){
                let JsonStr = {
                    socialInsurance: this.resumeNumber10,
                    isAccommodation: this.resumeNumber5 === '否' ? 1 : 2,
                    estimatedDate: this.resumeNumber9,
                    probationPeriod: this.resumeNumber8,
                    isGraduate: this.resumeNumber11,
                    sanhojo: this.resumeNumber14,
                    socialSecurityAccount: this.resumeNumber15,
                    cpfAccount: this.resumeNumber16,
                    bankCardNum: this.resumeNumber17,
                    bank: this.resumeNumber18,
                    resumeAttachments: this.resumeNumber1,

                }
                let data = {
                    realname: this.resumeNumber2,
                    // teach:'',
                    telephone: this.resumeNumber12,
                    email: this.resumeNumber13,
                    entryTime: this.resumeNumber6,
                    cardId: this.resumeNumber19,
                    deptId: this.deptId,
                    sex: this.resumeNumber4 === '男' ?  1 : 2,
                    formalTrainingDate: this.resumeNumber20,
                    extend: JSON.stringify(JsonStr),

                    emergencyContactName: this.resumeNumber31,
                    emergencyContactSite: this.resumeNumber32,
                    placeAbode: this.resumeNumber30,
                    certificateAnnex: JSON.stringify(this.resumeNumber33),

                    education: this.resumeNumber21,
                    categoryNames: this.resumeNumber22,
                    graduationSchool: this.resumeNumber23,
                }
                axios.post(`${apiBaseUrl}/teacher/addEntryTeacher/${this.resumesId ? this.resumesId : '' }`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{

                     console.log(res, '提交入职信息')

                    if(res.data.code == 200){
                        this.$message({type: 'success', message: '添加成功'})

                        let data = { offerStatus: 2, remark: '' }
                        axios.post(`${apiBaseUrl}/resumes-offer/modifyOffer/${this.resumesId}`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                            if(res.data.code == 200){

                            }else{
                                this.$message({type: 'error', message: res.data.message })
                            }
                        }).catch((err)=>{
                            this.$message({type: 'error', message: err })
                        })


                        this.$emit('handleEventChildren', false, 'success')
                    }else{
                        this.$message({type: 'error', message: res.data.message })
                    }
                }).catch((err)=>{
                    this.$message({type: 'error', message: err })
                })
           },

           handleShowAddTemplateDialogCler(){
               this.$emit('handleEventChildren', false)
           },

           handleShowUpload(){
               this.fileDataList = []
               this.uploadShowDlong = true
           },

           uploadShowDlongCler(){
               this.fileDataList = []
               this.uploadShowDlong = false

           },

           uploadShowDlongCler1(){
               this.fileDataList1 = []
               this.uploadShowDlong1 = false

           },

           uploadShowDlongSub(){
               this.resumeNumber3 = this.fileDataList[0].name
               this.resumeNumber3Url = this.fileDataList[0].url
               this.uploadShowDlong = false
           },

           uploadShowDlongSub1(){
               this.resumeNumber33 = this.fileDataList1
               this.uploadShowDlong1 = false
           },


           handleShowView(){

           },




           handleRemove(file, fileList){
               this.fileDataList = fileList
           },

           handleRemove1(file, fileList){
               this.fileDataList1 = fileList
           },

           getFileName(name) {
                return name.substring(name.lastIndexOf("."))
           },

           beforeUpload(file, fileList){
               loadingUtils.startLoading()
               const fileExtensions =
                   this.getFileName(file.name) === ".bmp" ||
                   this.getFileName(file.name) === ".tif" ||
                   this.getFileName(file.name) === ".gif" ||
                   this.getFileName(file.name) === ".pcx" ||
                   this.getFileName(file.name) === ".svg" ||
                   this.getFileName(file.name) === ".psd" ||
                   this.getFileName(file.name) === ".webp" ||
                   this.getFileName(file.name) === ".apng" ||
                   this.getFileName(file.name) === ".ai" ||
                   this.getFileName(file.name) === ".avif" ||
                   this.getFileName(file.name) === ".png" ||
                   this.getFileName(file.name) === ".pdf"||
                   this.getFileName(file.name) === ".mp4"||
                   this.getFileName(file.name) === ".excel"||
                   this.getFileName(file.name) === ".doc"||
                   this.getFileName(file.name) === ".ppt"||
                   this.getFileName(file.name) === ".mp3"||
                   this.getFileName(file.name) === ".xls"||
                   this.getFileName(file.name) === ".xlsx"||
                   this.getFileName(file.name) === ".pptx"||
                   this.getFileName(file.name) === ".docx"||
                   this.getFileName(file.name) === ".txt"||
                   this.getFileName(file.name) === ".jpg";
               const max20M = file.size / 1024 / 1024 < 1000;

               if (!fileExtensions) {
                this.$message({type: 'warning', message: '上传文件类不合格式' })
               }
               if (!max20M) {
                this.$message({type: 'warning', message: '上传文件类不合格式' })
               }

               return fileExtensions && max20M
           },

           beforeUpload1(file, fileList){
               loadingUtils.startLoading()
               const fileExtensions =
                   this.getFileName(file.name) === ".gif" ||
                   this.getFileName(file.name) === ".pcx" ||
                   this.getFileName(file.name) === ".svg" ||
                   this.getFileName(file.name) === ".psd" ||
                   this.getFileName(file.name) === ".webp" ||
                   this.getFileName(file.name) === ".apng" ||
                   this.getFileName(file.name) === ".ai" ||
                   this.getFileName(file.name) === ".avif" ||
                   this.getFileName(file.name) === ".png" ||
                   this.getFileName(file.name) === ".pdf"||
                   this.getFileName(file.name) === ".mp4"||
                   this.getFileName(file.name) === ".excel"||
                   this.getFileName(file.name) === ".doc"||
                   this.getFileName(file.name) === ".ppt"||
                   this.getFileName(file.name) === ".xls"||
                   this.getFileName(file.name) === ".xlsx"||
                   this.getFileName(file.name) === ".pptx"||
                   this.getFileName(file.name) === ".docx"||
                   this.getFileName(file.name) === ".txt"||
                   this.getFileName(file.name) === ".jpg";
               const max20M = file.size / 1024 / 1024 < 1000;

               if (!fileExtensions) {
                this.$message({type: 'warning', message: '上传证书文件类不合格式' })
               }
               if (!max20M) {
                this.$message({type: 'warning', message: '上传证书文件类不合格式' })
               }

               return fileExtensions && max20M
           },

           handleUpload(option){
               let obj = option.file.name
               let index = obj.lastIndexOf(".")
               obj = obj.substring(index, obj.length)
               let objName = option.file.name
               put(`mz_pc/${objName}`, option.file).then((res) => {
                   loadingUtils.endLoading()

                   let replacedStr = res.name.replace("mz_pc/", "")
                   res.name =  replacedStr

                   this.fileDataList.push(res)

                   signatureUrl(`mz_pc/${objName}`).then((res) => {})
               });
           },

           handleUpload1(option){
               let obj = option.file.name
               let index = obj.lastIndexOf(".")
               obj = obj.substring(index, obj.length)
               let objName = option.file.name
               put(`mz_pc/${objName}`, option.file).then((res) => {
                   loadingUtils.endLoading()

                   let replacedStr = res.name.replace("mz_pc/", "")
                   res.name =  replacedStr

                   this.fileDataList1.push(res)

                   signatureUrl(`mz_pc/${objName}`).then((res) => {})
               });
           },


           handleError(){
               loadingUtils.endLoading()
           },

           handleError1(){
               loadingUtils.endLoading()
           },

           handleDelet(){
               this.resumeNumber3 = ''
               this.resumeNumber3Url = ''
           },










       },



   }


   </script>

   <style lang="less" scoped>
        .btns{
           background-color: #428BCA;
           border-color: #428BCA;
           color: #fff;
       }
       .box{
           position: fixed;
           background: #fff;
           width: 50%;
           z-index: 1111;
           top: 160px;
           left: 26%;
           height: 50vh;
           margin: 0;
           padding-top: 70px;
           border: 1px solid #d5d0d0;
           border-radius: 10px;
       }

       /deep/ .el-progress__text{
            opacity: 0;
       }


       /deep/ .upload-demo{
          text-align: center;
       }

   </style>



// WEBPACK FOOTER //
// src/InterviewManagement/components/employmentComponents.vue